import { createFeature, createReducer, on } from "@ngrx/store";
import { CustomersData } from "../../interfaces";
import { LoadCustomersAction, LoadCustomersFailureAction, LoadCustomersSuccessAction, ResetCustomerAction, ResetCustomersAction, SetCustomerAction } from "./customers.actions";

export const CustomersDataFeatureName = 'CustomersData';

const initialState: CustomersData = {
    customers: [],
    isLoading: false,
    selectedCustomer: null
};

const reducer = createReducer (
    initialState,
    on(LoadCustomersAction, (state) => ({ ...state, isLoading: true })),
    on(SetCustomerAction, (state, { customer }) => ({ ...state, selectedCustomer: customer })),
    on(ResetCustomersAction, (state) => ({ ...state, customers: [], isLoading: false })),
    on(ResetCustomerAction, (state) => ({ ...state, selectedCustomer: null })),
    on(LoadCustomersSuccessAction, (state, { customers }) => ({ ...state, customers, isLoading: false })),
    on(LoadCustomersFailureAction, (state) => ({ ...state, customers: [], isLoading: false }))
);

export const CustomersDataFeature = createFeature({
    name: CustomersDataFeatureName,
    reducer: reducer
});